import { CloseIcon } from '@chakra-ui/icons';
import { Flex, Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import FullScreenLoader from 'components/FullScreenLoader';
import { HEADER_HEIGHT_WITH_NAVIGATION, STATUS } from 'projectConstants';
import { fetchPropertyValue, getPropertyValueStatus } from 'redux/DimensionPageSlice';
import { closeInputSection, getSelectedDriver } from 'redux/PlanPageSlice';
import { getBaseScenario } from 'redux/ScenarioSlice';
import { AppDispatch } from 'utils/GlobalHelpers';
import {
  PLAN_HEADER_HORIZONTAL_PADDING,
  PLAN_REVAMP_RADIUS_SM,
  PLAN_TEXT,
  accent,
  neutral,
  text as textToken,
} from 'pages/PlanRevamp/PlanPageUIRevamp/planPageRevampUi';

import PropertyTable from './PropertyTable';

interface Properties {
  refetchRequest: () => void;
}

const DimesionPage = ({ refetchRequest }: Properties) => {
  const dispatch: AppDispatch = useDispatch();
  const currentDriver = useSelector(getSelectedDriver);
  const baseScenario = useSelector(getBaseScenario);

  useEffect(() => {
    dispatch(
      fetchPropertyValue({
        propertyId: currentDriver?.property_id,
        parameters: { scenario_id: baseScenario?.id },
      }),
    );
  }, [currentDriver, baseScenario?.id, dispatch]);

  const isLoading = useSelector(getPropertyValueStatus);

  const closeSection = () => {
    dispatch(closeInputSection());
  };

  if (isLoading !== STATUS.SUCCESS) {
    return <FullScreenLoader />;
  }

  return (
    <Flex
      display='flex'
      flexDirection='column'
      overflowY='auto'
      h={`calc(100vh - ${HEADER_HEIGHT_WITH_NAVIGATION})`}
      width='100%'
      px={PLAN_HEADER_HORIZONTAL_PADDING}
      py='12px'
    >
      <Flex justifyContent='space-between' alignItems='center' mb='12px'>
        <Text {...PLAN_TEXT.panelTitle} color={textToken.primary} noOfLines={1}>
          {currentDriver.property_name}
        </Text>
        <Flex
          as='button'
          type='button'
          aria-label='Close property panel'
          alignItems='center'
          justifyContent='center'
          h='28px'
          w='28px'
          minW='28px'
          flexShrink={0}
          border='1px solid'
          borderColor={neutral.border}
          borderRadius={PLAN_REVAMP_RADIUS_SM}
          bg={neutral.surface}
          color={textToken.secondary}
          cursor='pointer'
          transition='background 0.12s ease, border-color 0.12s ease, color 0.12s ease'
          _hover={{
            bg: neutral.surfaceHover,
            borderColor: neutral.borderStrong,
            color: accent.solid,
          }}
          onClick={closeSection}
        >
          <CloseIcon boxSize='11px' />
        </Flex>
      </Flex>
      <Flex direction='column'>
        <PropertyTable
          propertyId={currentDriver.property_id}
          dimensionName={currentDriver.dim_name}
          dimensionId={currentDriver.dimension_id}
          propertyName={currentDriver.property_name}
          refetchRequest={refetchRequest}
        />
      </Flex>
    </Flex>
  );
};

export default DimesionPage;
